import React from 'react'
import {CardPaymentIcon, AchTransferIcon, ArrowRightIcon} from '../../assets'
import {AutopayTerms} from './autopay-terms'
import {useUserFeatures} from '../../context/user-features-context'
import {usePaymentOrder} from './hooks/use-payment-order'
import {usePaymentCheckboxes} from './contexts/payment-checkboxes-context'
import {toast} from 'react-toastify'
import {Toggle} from '../../core/shared/Toggle'

const PaymentMethod = ({
  paymentMethod,
  handleChangePaymentMethod,
  paymentMethods,
  isDesktop,
  isLoading = false,
  showMethodIcons = true,
}) => {
  const {is5Order} = usePaymentOrder()
  const {
    checkBoxesValues: {agreedTerms},
  } = usePaymentCheckboxes()
  const {Updated_Terms: frontendUpdatedTerms} = useUserFeatures()

  const tabs = paymentMethods.map(method => {
    const isPlaid = method.name === 'Bank Transfer with ACH' && is5Order
    return {
      label: isPlaid
        ? 'Transfer with ACH'
        : method.value === 'card'
        ? 'Pay with Card'
        : method.name,
      value: method.value,
      icon: method.icon,
      isPlaid,
    }
  })

  const activeIndex = paymentMethods.findIndex(
    m => m.value === paymentMethod.value,
  )

  const handleChange = (tab, index) => {
    if (agreedTerms) {
      toast.warn(
        'To update your payment method or address, please uncheck the Terms & Conditions box.',
      )
      return
    }
    handleChangePaymentMethod(paymentMethods[index])
  }

  if (!isDesktop) {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        {tabs.map((tab, index) => {
          const isActive = index === activeIndex
          return (
            <button
              key={tab.value}
              onClick={() => handleChange(tab, index)}
              disabled={isLoading}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 16px',
                border: `2px solid ${isActive ? '#5378FC' : '#DDE1EA'}`,
                borderRadius: '10px',
                background: isActive ? '#F0F3FF' : '#ffffff',
                cursor: isLoading || agreedTerms ? 'not-allowed' : 'pointer',
                opacity: (isLoading || agreedTerms) && !isActive ? 0.5 : 1,
                width: '100%',
                textAlign: 'left',
              }}
            >
              <div
                style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: `2px solid ${isActive ? '#5378FC' : '#9CA3AF'}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {isActive && (
                  <div
                    style={{
                      width: '9px',
                      height: '9px',
                      borderRadius: '50%',
                      background: '#5378FC',
                    }}
                  />
                )}
              </div>
              {tab.value === 'ach' ? (
                <AchTransferIcon color={isActive ? '#5378FC' : '#3D5199'} />
              ) : (
                <CardPaymentIcon color={isActive ? '#5378FC' : '#3D5199'} />
              )}
              <span
                style={{
                  fontFamily: 'Open Sans',
                  fontSize: '14px',
                  fontWeight: isActive ? 700 : 400,
                  color: isActive ? '#5378FC' : '#4D4D4D',
                }}
              >
                {tab.label}
              </span>
            </button>
          )
        })}
        {isLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '16px',
            }}
          >
            <div
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '3px solid #DDE1EA',
                borderTopColor: '#5378FC',
                animation: 'spin 0.7s linear infinite',
              }}
            />
          </div>
        )}
        {frontendUpdatedTerms && <AutopayTerms />}
      </div>
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
      }}
    >
      <div
        style={{
          pointerEvents: isLoading ? 'none' : 'auto',
          opacity: isLoading || agreedTerms ? 0.6 : 1,
          width: '100%',
        }}
      >
        <Toggle
          tabs={tabs}
          activeIndex={activeIndex}
          onChange={handleChange}
          variant="pillFilled"
          fullWidth={!showMethodIcons}
          renderTab={(tab, isActive) => (
            <>
              {showMethodIcons &&
                (tab.value === 'ach' ? (
                  <AchTransferIcon color={isActive ? '#ffffff' : '#3D5199'} />
                ) : (
                  <CardPaymentIcon color={isActive ? '#ffffff' : '#3D5199'} />
                ))}
              {tab.label}
              {isActive && <ArrowRightIcon />}
            </>
          )}
        />
      </div>
      {isLoading && (
        <div
          style={{
            width: '18px',
            height: '18px',
            borderRadius: '50%',
            border: '2px solid #DDE1EA',
            borderTopColor: '#5378FC',
            animation: 'spin 0.7s linear infinite',
            flexShrink: 0,
          }}
        />
      )}
    </div>
  )
}

export {PaymentMethod}
